import { getLastSentThirdPartySubject, onCallSavedThirdParty } from './hsCalling';
const isOutboundCallFromPage = dialNumberDetails => {
  const lastSentThirdPartySubject = getLastSentThirdPartySubject();
  if (!dialNumberDetails || !lastSentThirdPartySubject) {
    return false;
  }
  return String(lastSentThirdPartySubject.objectId) === String(dialNumberDetails.objectId) && lastSentThirdPartySubject.objectTypeId === dialNumberDetails.objectTypeId;
};
export const handleCallCompletedEvent = message => {
  const {
    dialNumberDetails,
    engagementId
  } = message.payload;
  if (engagementId && isOutboundCallFromPage(dialNumberDetails)) {
    // Trigger onCallSaved event to create associations in CallProviderViewport
    onCallSavedThirdParty({
      engagementId
    });
  }
};